import { Goods } from '../../types/Endpoints/orders/OrdersContracts';

export const totalOrderCount = (goods: Goods[]) => goods.reduce((total, item) => total + parseInt(item.quantity, 10), 0);
